module.exports = __webpack_public_path__ + "static/img/product_finance_BOD.5d2f719.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_finance_BOD.svg
// module id = yzBP
// module chunks = 0